// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"e69c13d9","488":"457aaab7","615":"fa90edd2"}[chunkId] + ".chunk.js";
};